module.exports = __webpack_public_path__ + "images/emoji/gun.f4d965aa60edd2d57767.png";